module.exports = __webpack_public_path__ + "static/media/Avatars_Other_New-07.b2dfb143.jpg";